// extracted by mini-css-extract-plugin
module.exports = {"logos":"Logos-module__logos___28R5x","mc":"Logos-module__mc___23sbE","visa":"Logos-module__visa___2H1Ai","mir":"Logos-module__mir___SKrwq"};